import { css } from '@emotion/css';
import { useTheme } from '@mui/material';

export const useFooterStyles = () => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.mode === 'dark';

  return {
    footer: css({
      width: '100%',
      backgroundColor: theme.palette.background.default,
      padding: '2rem',
      boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)', // Optional: Shadow
      position: 'relative',
      bottom: 0,
    }),
    sectionTitle: css({
      fontWeight: 'bold',
      marginBottom: '10px',
    }),
    link: css({
      display: 'block',
      marginBottom: '8px',
      color: isDarkTheme ? theme.palette.text.secondary : theme.palette.text.primary,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
    }),
    contactText: css({
      color: theme.palette.text.disabled,
    }),
    socialIcon: css({
      '& .MuiSvgIcon-root': {
        color: isDarkTheme ? '#ffffff' : theme.palette.text.primary,
      },
      '&:hover .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    }),
    socialIconsContainer: css({
      display: 'flex',
      gap: '10px',
    }),
  };
};
